import React from "react";
import PropTypes from "prop-types";
import { uniq } from "lodash";

import { Header, Icon } from "semantic-ui-react";

export function StaticBulletList({ header, legend, items, color }) {
  const uniqueItems = uniq(items);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.7em" }}>
      {header && (
        <Header as="h1" data-test="list-header">
          {header}
        </Header>
      )}
      {legend && (
        <div data-test="list-legend" style={{ marginBottom: "1em" }}>
          {legend}
        </div>
      )}
      {uniqueItems.map((item) => {
        return (
          <div style={{ display: "flex", textAlign: "left" }} key={item}>
            <Icon
              name="check circle"
              color={color}
              data-test="list-entry-icon"
            />
            {item}
          </div>
        );
      })}
    </div>
  );
}

StaticBulletList.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  legend: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  items: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
};

StaticBulletList.defaultProps = {
  header: undefined,
  legend: undefined,
  items: [],
  color: "blue",
};

export default StaticBulletList;
